import React from "react";

// Brand assets live in /public so they resolve at the site root in both the
// authenticated app and the public catalogue.
export const LOGO_MARK = "/jastip-mark.png";
export const LOGO_FULL = "/jastip-logo-full.png";

export function LogoMark({ className = "h-9 w-9", alt = "Jastip" }) {
  return <img src={LOGO_MARK} alt={alt} className={`object-contain ${className}`} draggable={false} />;
}

export function LogoFull({ className = "h-9", alt = "Jastip by May Apps" }) {
  return <img src={LOGO_FULL} alt={alt} className={`object-contain ${className}`} draggable={false} />;
}

// Square, brand-tinted placeholder used when a product has no photo.
export function ProductPlaceholder({ className = "" }) {
  return (
    <div className={`h-full w-full flex items-center justify-center bg-secondary ${className}`}>
      <img src={LOGO_MARK} alt="" aria-hidden="true" className="h-1/2 w-1/2 object-contain opacity-30" draggable={false} />
    </div>
  );
}
